import Login from './views/Login.vue'
import NotFound from './views/404.vue'
import Home from './views/Home.vue'
import Main from './views/Main.vue'
import Table from './views/nav1/Table.vue'

import FileList from './views/nav1/FileList.vue'
import AddFile from './views/nav1/AddFile.vue'
import FileInfo from './views/nav1/FileInfo.vue'
import AlterFile from './views/nav1/AlterFile.vue'


import Form from './views/nav1/Form.vue'
import user from './views/nav1/user.vue'
import Page4 from './views/nav2/Page4.vue'
import Page5 from './views/nav2/Page5.vue'
import Page6 from './views/nav3/Page6.vue'
import echarts from './views/charts/echarts.vue'

let routes = [
    // {
    //     path: '/login',
    //     component: Login,
    //     name: '',
    //     hidden: true
    // },
    // {
    //     path: '/404',
    //     component: NotFound,
    //     name: '',
    //     hidden: true
    // },
    // 
		
    {
        path: '/',
        // component: Home,
				component: Home,
        name: '文件列表',
        iconCls: 'el-icon-document',//图标样式class
				leaf: true,//只有一个节点
        children: [
					{ path: '/', component: FileList, name: '文件列表' },
					{ path: '/fileList', component: FileList, name: '文件列表' },
					{ path: '/addFile', component: AddFile, name: '新增文件', hidden: true},
					{ path: '/fileInfo', component: FileInfo, name: '文件详情', hidden: true},
				  { path: '/alterFile', component: AlterFile, name: '修改文件', hidden: true},
        ]
    },
    
    {
        path: '*',
        hidden: true,
        redirect: { path: '/404' }
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/routes.js